import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

// Import your images here (make sure the paths are correct)
import Generative from '../assets/services/gen-ai.webp';
import app from '../assets/services/app.webp';
import staff from '../assets/services/staff-augmentation.webp';
import devops from '../assets/services/devops.webp';
import UIux from '../assets/services/UIux.webp';
import webdev from '../assets/services/webdev.webp';
import software from '../assets/services/Custom-software-development.webp';
import Data from '../assets/services/Data-Analytics.webp';
import Cloud from '../assets/services/Cloud-Integration.webp';
import quality from '../assets/services/quality-assurance.webp';
import SaaS from '../assets/services/SaaS.webp';
import ecommerce from '../assets/services/ecommerce.webp';
import design from '../assets/services/web-design.webp';
import maintenancee from '../assets/services/Maintenance-Support.webp';
import automation from '../assets/services/automation-apps.webp';

const ServicesSection = () => {
  const navigate = useNavigate();
  const [more, setMore] = useState(null);

  useEffect(() => {
    if (more !== null) {
      const element = document.getElementById('services');
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }
  }, [more]);

  const services = [
    { name: "Generative AI", image: Generative },
    { name: "Mobile App Development", image: app },
    { name: "Staff Augmentation", image: staff },
    { name: "DevOps", image: devops },
    { name: "UI/UX Design", image: UIux },
    { name: "Web Development", image: webdev },
    { name: "Custome Software Development", image: software },
    { name: "Data Analytics & Insights", image: Data },
    { name: "Cloud Maintainance & Integration", image: Cloud },
    { name: "Quality Assurance", image: quality },
    { name: "SaaS", image: SaaS },
    { name: "E-commerce", image: ecommerce },
    { name: "Design & Development", image: design },
    { name: "Maintainance & Support", image: maintenancee },
    { name: "Automation & Apps", image: automation },
  ];

  const containerVariants = {
    hidden: {},
    visible: {
      transition: {
        staggerChildren: 0.15,
      },
    },
  };

  const cardVariants = {
    hidden: { opacity: 0, scale: 0.95, y: 30 },
    visible: {
      opacity: 1,
      scale: 1,
      y: 0,
      transition: { type: 'spring', stiffness: 120, damping: 20 },
    },
  };

  const headingVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } },
  };

  const buttonHover = {
    scale: 1.05,
    boxShadow: "0px 8px 15px rgba(0,0,0,0.3)",
    transition: { type: "spring", stiffness: 300, damping: 20 },
  };

  return (
    <div
      id="services"
      className="flex flex-col items-center justify-center p-2 lg:p-10 max-w-7xl mx-auto gap-y-10 text-center lg:mt-10"
    >
      {/* Heading */}
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.4 }}
        variants={headingVariants}
      >
        <h1 className="font-extrabold text-2xl lg:text-4xl text-gray-700">
          DevSpots Services to Transform Your Business
        </h1>
      </motion.div>

      {/* Service Cards Grid */}
      <motion.div
        className={`grid grid-cols-1 gap-x-6 gap-y-10 sm:grid-cols-3 xl:grid-cols-3 xl:gap-x-8 mt-6 pt-6 transition-max-height duration-500 ${
          more
            ? 'max-h-auto'
            : 'lg:max-h-[295px] md:max-h-[280px] sm:max-h-[255px] max-h-[246px] xs:max-h-[100px] overflow-hidden'
        }`}
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, amount: 0.3 }}
        variants={containerVariants}
      >
        {services.map(({ name, image }, index) => (
          <motion.div
            key={index}
            className="group relative hover:-mt-3 hover:mb-3 transition-all duration-500 rounded-xl cursor-pointer"
            variants={cardVariants}
            whileHover={{ scale: 1.05, zIndex: 10 }}
          >
            <h3 className="mt-5 mx-5 absolute top-0 text-white text-2xl font-bold z-20 text-start cursor-default">
              {name}
            </h3>
            <img
              alt={"img" + index}
              src={image}
              className="xl:aspect-[7/5] sm:aspect-square aspect-[1/0.6] w-full rounded-xl bg-gray-200 object-cover"
            />
            <div className="absolute inset-0 bg-[#202020] opacity-50 rounded-xl"></div>
          </motion.div>
        ))}
      </motion.div>

      {/* View More / View Less Button */}
      <motion.button
        onClick={() => {
          if (more) navigate('#services');
          setMore(!more);
        }}
        className="bg-[#000B27] rounded-full py-4 px-14 text-white font-semibold text-l w-fit mt-2 hover:shadow-xl"
        whileHover={buttonHover}
        whileTap={{ scale: 0.95 }}
      >
        {more ? 'View Less' : 'View More'}
      </motion.button>
    </div>
  );
};

export default ServicesSection;
